var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "27px",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heart_inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-328.000000, -3150.000000)",
    fillRule: "nonzero",
    stroke: "#F5416D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 3034.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(252.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.82795907,14.0683416 L14.8396834,26.080066 C14.9282239,26.1686065 15.0717761,26.1686065 15.1603166,26.080066 L27.1720409,14.0683416 C30.2759864,10.9643962 30.2759864,5.93190587 27.172041,2.82795914 C24.0680941,-0.275986368 19.0356038,-0.275986368 15.9316578,2.82795963 C15.6155154,3.14410098 15.4658865,3.32794081 15.4283997,3.39022855 L15.0627995,3.99770686 L14.6133168,3.44938327 C14.537452,3.35683585 14.41919,3.21587253 14.2966042,3.07615564 C14.2781906,3.05520362 14.2781906,3.05520362 14.2598034,3.03443012 C14.183378,2.94825111 14.1178495,2.87746694 14.0683416,2.82795907 C10.9643962,-0.275986368 5.93190587,-0.275986368 2.82795914,2.82795899 C-0.275986368,5.93190587 -0.275986368,10.9643962 2.82795907,14.0683416 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartInactive);
export default __webpack_public_path__ + "static/media/heart_inactive.1f075839fc8da2598429327e2a23c8d2.svg";
export { ForwardRef as ReactComponent };